import { render, staticRenderFns } from "./Rapaces.vue?vue&type=template&id=8b3efb70&scoped=true"
import script from "./Rapaces.vue?vue&type=script&lang=js"
export * from "./Rapaces.vue?vue&type=script&lang=js"
import style0 from "./Rapaces.vue?vue&type=style&index=0&id=8b3efb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3efb70",
  null
  
)

export default component.exports